import { disableBodyTouch } from "../../../utils/validators";

export default function WVDisableBodyTouch({ disableTouch }) {
  disableBodyTouch(disableTouch);
  return null;
}